import {  Form, Input, Select, TimePicker, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import ProgramTable from "../ProgramTable/ProgramTable";
import TextEditor from "../TextEditor/TextEditor";
import styles from "./PlacementTestForm.module.css";
import dayjs from "dayjs";
import { DatePicker } from "antd-jalali";
import { useEffect } from "react";
import { useState } from "react";
import FormExportDropdown from "../FormExportDropdown/FormExportDropdown";
import PlacementTestMapper from "../../util/PlacementTestMapper";
import api from "../../api/api";
import { connect } from "react-redux";

const { Option } = Select;

const PlacementTestForm = ({
  onSubmit,
  loading,
  disabled,
  EditButton,
  editMode,
  ToggleEditMode,
  initialValues,
  uploadProps,
  exportFileName,
  token,
  levels,
  LevelSetter
}) => {
  const [form] = Form.useForm();
  const [voiceFile, setVoiceFile] = useState(
    form.getFieldValue("recorded_voice")
  );
  const [presonalityOptions, setPersonalityOptions] = useState([])

  useEffect(() => {
    setVoiceFile(initialValues.recorded_voice);
  }, [initialValues]);
  const initialValuesNormalized = {
    ...initialValues,
    study_amount: initialValues.study_amount
      ? dayjs(initialValues.study_amount, "HH:mm:ss")
      : dayjs("00:00:00", "HH:mm:ss"),
    deadline: initialValues.deadline ? dayjs(initialValues.deadline) : 0,
  };
  useEffect(() => {
    api.get('/personalities', {
      headers: {
        Authorization: 'Token ' + token
      }
    }).then((value) => {
      const options = Array.isArray(value.data) && value.data.map((val) => {
        return { label: val, value: val }
      })
      setPersonalityOptions(options)
    })


  }, [])
  return (
    <>
      <EditButton
        loading={loading}
        submit={form.submit}
        editMode={editMode}
        ToggleEditMode={ToggleEditMode}
        onCancel={() => {
          form.setFieldsValue(initialValuesNormalized);
        }}
      />
      {!editMode && (
        <div className={styles.FormExportDropdown}>
          <FormExportDropdown
            tableId="ProgramTable"
            data={initialValues}
            mapper={PlacementTestMapper}
            name={exportFileName}
            LevelSetter={LevelSetter}
          />
        </div>
      )}
      <Form
        className={styles.SignUpFormData}
        initialValues={initialValuesNormalized}
        disabled={disabled}
        layout="vertical"
        form={form}
        name="register"
        onFinish={onSubmit}
        scrollToFirstError
      >
        <div className={styles.DataContainer}>
          <div className={styles.RightSide}>
            <h2>اطلاعات اولیه</h2>
            <Form.Item name="personalities" label="نکات شخصیتی">
              <Select
                style={{
                  width: "100%",
                }}
                mode="tags"
                dropdownAlign="right"
                placeholder="نکات شخصیتی را انتخاب کنید:"
                options={presonalityOptions}


              />
            </Form.Item>
            <Form.Item name="considerations" label="ملاحظات آموزشی">
              <TextEditor className={styles.TextEditor} disabled={disabled} />
            </Form.Item>
            <Form.Item name="aim_to_learn" label="هدف از یادگیری">
              <TextEditor className={styles.TextEditor} disabled={disabled} />
            </Form.Item>
            <Form.Item label="صدای ضبط شده">
              <Form.Item name="recorded_voice" noStyle>
                {voiceFile ? <audio controls src={voiceFile} /> : null}
                <Upload.Dragger
                  multiple={false}
                  name="files"
                  accept="audio/*"
                  maxCount={1}
                  {...uploadProps}
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    کلیک کنید یا فایل را به داخل این جعبه بکشید.
                  </p>
                  <p className="ant-upload-hint">
                    یک یا چند فایل را می‌توانید قرار دهید.
                  </p>
                </Upload.Dragger>
              </Form.Item>
            </Form.Item>
          </div>
          <div className={styles.RightSide}>
            <h2>اطلاعات کلاس</h2>
            <Form.Item name="deadline" label="ددلاین‌های زمانی">
              <DatePicker showNow={false} style={{ width: "100%" }} />
            </Form.Item>

            <Form.Item name="class_type" label="نحوه برگزاری کلاس">
              <Select placeholder="نحوه برگزاری کلاس">
                <Option value="AT">حضوری</Option>
                <Option value="ON">مجازی</Option>
                <Option value="MI">دو نفره</Option>
              </Select>
            </Form.Item>
            <Form.Item name="study_amount" label="میزان مطالعه در روز">
              <TimePicker
                secondStep={30}
                hideDisabledOptions
                showNow={false}
                placeholder=":میزان مطالعه در روز را وارد کنید"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <h2>برنامه درسی پیشنهادی</h2>
            <Form.Item name="description" label="توضیحات">
              <Input.TextArea placeholder="توضیحات" style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item label="سطح زبان آموز">
              <Input.Group compact style={{ display: "flex", width: "100%" }}>
                <Form.Item name="level" noStyle>
                  <Select
                    style={{ width: "50%" }}
                    placeholder="سطح زبان را انتخاب کنید:"
                  >
                    {levels.map((level) => {
                      return <Option value={level.value}>{level.text}</Option>;
                    })}
                  </Select>
                </Form.Item>
                <Form.Item name="proficiency" noStyle>
                  <Select
                    style={{ width: "50%" }}
                    placeholder="کیفیت سطح زبان را انتخاب کنید:"
                  >
                    <Option value={1}>ضعیف</Option>
                    <Option value={2}>متوسط</Option>
                    <Option value={3}>خوب</Option>
                  </Select>
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item name="curriculum" label="جدول برنامه ریزی">
              <ProgramTable
                levels={levels}
                disabled={disabled}
                setValue={(value) => {
                  form.setFieldValue("curriculum", value);
                }}
              />
            </Form.Item>
          </div>
        </div>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.token,
    loading: state.loading
  };
};

export default connect(mapStateToProps)(PlacementTestForm);
